const spaces = [
  {
    name: "Nairana Home",
    description: "Property assistant — appliances, systems, trade contacts",
    url: "https://www.perplexity.ai/spaces/nairana-46-nairana-rest-PCwElbsbRfKgEsrVLT9y4Q",
    icon: "🏠",
  },
  {
    name: "Defender & Expedition",
    description: "4x4 and camping reference",
    url: "https://www.perplexity.ai/spaces/defender-expedition-s2MOD0kvQ467vwKegMiaww",
    icon: "🚙",
  },
  {
    name: "Travel",
    description: "Travel planning and destinations",
    url: "https://www.perplexity.ai/spaces/travel-hE.KosrpS5ydm8c47Q8BOQ",
    icon: "✈️",
  },
  {
    name: "Health & Longevity",
    description: "Health protocols and records",
    url: "https://www.perplexity.ai/spaces/health-longevity-sjUqD8p0ToCfuH5ppF5yPQ",
    icon: "💚",
  },
  {
    name: "Sandeu DLS Guide",
    description: "DLS operating guide",
    url: "https://www.perplexity.ai/spaces/sandeu-dls-guide-syp7w61MRU2hJHCyUUoOaQ",
    icon: "📘",
  },
];

export default function PerplexityView() {
  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {spaces.map((space) => (
          <a
            key={space.name}
            href={space.url}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white rounded-2xl border border-slate-200/70 shadow-[0_1px_2px_rgba(15,23,42,0.04)] p-5 flex items-start gap-4 hover:shadow-md hover:border-[#4A6D8C]/40 transition-all"
          >
            <span className="text-2xl mt-0.5">{space.icon}</span>
            <div className="min-w-0">
              <h3 className="font-semibold text-slate-900 text-base">
                {space.name}
              </h3>
              <p className="text-sm text-slate-500 mt-1">{space.description}</p>
              <span className="inline-block mt-3 text-xs font-medium text-[#1B3A5C]">
                Open in Perplexity &rarr;
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
